export const I18N_PARTIAL_ACTIONS_ES = {
  ACTION: {
    SINGULAR: 'Acciones',
    PLURAL: 'Acciones',
    ADD: { GENERIC: 'Añadir' },
    RELOAD: { GENERIC: 'Recargar' },
    SEARCH: { GENERIC: 'Buscar' },
    SAVE: { GENERIC: 'Guardar', AND_CONTINUE: 'Guardar y continuar' },
    EDIT: { GENERIC: 'Editar' },
    DISCARD: { GENERIC: 'Resetear' },
    CANCEL: { GENERIC: 'Cancelar' },
    SEND: { GENERIC: 'Enviar', EMAIL: 'Enviar email' },
    CLOSE: { GENERIC: 'Salir' },
    AGREE: { GENERIC: 'Aceptar', IAGREE: 'Estoy de acuerdo' },
    CONFIRM: {
      GENERIC: '¡Ok lo tengo!',
      YES: 'Si, seguro',
      DELETED: '¡Sí, eliminar!',
      ACCOUNT: 'Confirmar cuenta',
    },
    DETAIL: { GENERIC: 'Detalle', VIEW: 'Ver detalle' },
    APPLY: { GENERIC: 'Aplicar' },
    ACCESS: { GENERIC: 'Acceder' },
    UPDATE: { GENERIC: 'Actualizar' },
    REGISTER: { GENERIC: 'Registrarse' },
    CONTINUE: { GENERIC: 'Continuar' },
    FINALIZE: { GENERIC: 'Finalizar' },
    GO_BACK: { GENERIC: 'Regresar', LIST: 'Regresar al listado' },
    NEW: { GENERIC: 'Nuevo' },
    EVALUATE: { GENERIC: 'Evaluar' },
    GO: { GENERIC: 'Ir' },
    REMOVE: { GENERIC: 'Eliminar', CLEAN: 'Limpiar' },
    UPLOAD: { GENERIC: 'Subir' },
    FILTER: { GENERIC: 'Filtrar' },
    SELECT: { GENERIC: 'Seleccionar', DATE: 'Seleccionar fecha' },
    IMPORT: { GENERIC: 'Importar', DATA: 'Importar datos' },
    SING_IN: { GENERIC: 'Iniciar' },
    TODAY: 'Hoy',
  },
};

export const I18_PARTIAL_VALIDATIONS_RULES_ES = {
  VALIDATION: {
    REQUIRED: 'Campo obligatorio.',
    MIN_LENGTH:
      'Este valor es demasiado corto. Debería tener {{ min }} caracteres o más.',
    MAX_LENGTH:
      'Este valor es demasiado largo. Debería tener {{ max }} caracteres o menos.',
    MIN: 'Ingrese un valor mayor o igual a {{ min }}.',
    MAX: 'Ingrese un valor menor o igual a {{ max }}.',
    RANGE: 'Ingrese un valor entre {{ min }} y {{ max }}.',
    DATE: 'Este valor no es una fecha válida.',
    DATETIME: 'Este valor no es una fecha y hora válidas.',
    EMAIL: 'Este valor no es una dirección de email válida.',
    URL: 'Este valor no es una URL válida.',
    PASSWORD_MATCH: 'Las contraseñas no coinciden.',
    PASSWORD_STRENGTH:
      'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número, un carácter especial y no menos de {{ length }} caracteres.',
  },
};

export const I18_PARTIAL_ALERTS_ES = {
  ALERT: {
    SUCCESS: 'Operación completada correctamente',
    CONFIRM_TITLE: '¿Está seguro?',
    CONFIRM_TEXT: '¡No podrás revertir esta operación!',
    CONFIRM_BUTTON_TEXT: 'Si, seguro',
    DEFAULT_CONFIRM_BUTTON_TEXT: '¡Ok lo tengo!',
    DEFAULT_CANCEL_BUTTON_TEXT: 'Cancelar',
    ERROR_TITLE: 'Ha ocurrido un error',
    ERROR:
      'Lo sentimos, parece que se han detectado algunos errores. Vuelve a intentarlo.',
  },
  ERROR: {
    FORBIDDEN: 'No tienes permiso para realizar esta acción.',
    EMAIL_ALREADY_REGISTERED: 'Ese correo electrónico ya está registrado.',
    EMAIL_ALREADY_IN_USE: 'Ese correo electrónico ya está en uso.',
    TOO_MANY_REQUESTS:
      'Demasiados intentos. Espera un momento e inténtalo de nuevo.',
  },
};

export const I18N_PARTIAL_TIME_PERIODICITY_ES = {
  PERIODICITY: {
    NONE: 'Ninguna',
    TODAY: 'Hoy',
    IN: 'En',
    AGO: 'Hace',
    SINCE: 'Desde hace',
    EVERY_WEEK: 'Semanalmente',
    EVERY_DAY: 'Diariamente',
    EVERY_CERTAIN_DAYS: 'Cada {{value}} días',
    EVERY_CERTAIN_WEEKS: 'Cada {{value}} semanas',
    EVERY_MONTH: 'Mensualmente',
    EVERY_QUARTER: 'Cada trimestre',
    EVERY_SEMESTER: 'Cada semestre',
    EVERY_CERTAIN_MONTHS: 'Cada {{value}} meses',
    EVERY_YEAR: 'Anual',
    EVERY_CERTAIN_YEARS: 'Cada {{value}} años',
    YEARS: 'Años',
    YEAR: 'Año',
    MONTHS: 'Meses',
    MONTH: 'Mese',
    DAYS: 'Días',
    DAY: 'Día',
    WEEKS: 'Semanas',
    WEEK: 'Semana',
    HOURS: 'Horas',
    HOUR: 'Hora',
    MINUTES: 'Minutos',
    MINUTE: 'Minuto',
    SECONDS: 'Segundos',
    SECOND: 'Segundo',
  },
};

export const I18N_PARTIALS_ES = {
  ...I18N_PARTIAL_ACTIONS_ES,
  ...I18_PARTIAL_VALIDATIONS_RULES_ES,
  ...I18N_PARTIAL_TIME_PERIODICITY_ES,
  ...I18_PARTIAL_ALERTS_ES,
};
